import { LoadingSpinnerState } from "./type";

export const getLoadingSpinnerVisibilityState = (state: LoadingSpinnerState) => state.visible;


// WEBPACK FOOTER //
// ./src/store/LoadingSpinner/selectors.ts